import React from "react";
import { Chip } from "../../themeV2";
import s from "./Badges.module.css";

export default function FamilyMember() {
  return <Chip label="Streamily Family Member" className={s.gradient} />;
}
